import { render, staticRenderFns } from "./home_pink.vue?vue&type=template&id=29a734cc&scoped=true&"
import script from "./home_pink.vue?vue&type=script&lang=js&"
export * from "./home_pink.vue?vue&type=script&lang=js&"
import style0 from "./home_pink.vue?vue&type=style&index=0&id=29a734cc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a734cc",
  null
  
)

export default component.exports